import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { PlessSharedModule } from '../../../shared/pless-shared.module';

import { KYMW9101Module } from '../kymw9101/kymw9101.module';
import { KYMW9100Component } from './kymw9100.component';
import { FileDownloadConfirmService } from '../../../commons/kymw02/file-download-confirm/file-download-confirm.service';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { GetLogDataService } from './api-services/get-log-data.service';
import { OutputLogFileService } from './api-services/output-log-file.service';

/**
 * ログ検索画面 モジュール設定クラス
 *
 * @export KYMW9100Module
 * @class KYMW9100Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    WjGridModule,
    KYMW9101Module,
    AppCommonsModule,
  ],
  declarations: [
    KYMW9100Component,
  ],
  providers: [
    GetLogDataService,
    OutputLogFileService,
    FileDownloadConfirmService,
  ],
})
export class KYMW9100Module {

}
